import React, { useState } from "react";
import { Empty } from "antd";
import FeatherIcon from "feather-icons-react";
import { string, arrayOf, shape } from "prop-types";

const QuestionProfileCard = ({ questions }) => {
  if (!questions || questions.length === 0) {
    return <Empty description="No existe información" />;
  }

  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const currentQuestion = questions[currentQuestionIndex];

  const handleNextQuestion = () => {
    setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
  };

  const handlePreviousQuestion = () => {
    setCurrentQuestionIndex((prevIndex) => prevIndex - 1);
  };

  let stateValue = true;
  let goalValue = "";
  //Variables for pressure
  let asistolic = 0;
  let diastolic = 0;
  let asistolicMin = 0;
  let asistolicMax = 0;
  let diastolicMin = 0;
  let diastolicMax = 0;

  switch (currentQuestion.measure) {
    case "RangeGoal":
      stateValue =
        parseFloat(currentQuestion.currentValue) >=
          parseFloat(currentQuestion.minGoal) &&
        parseFloat(currentQuestion.currentValue) <=
          parseFloat(currentQuestion.maxGoal);
      goalValue = currentQuestion.minGoal + " - " + currentQuestion.maxGoal;
      break;
    case "Goal":
      stateValue =
        parseFloat(currentQuestion.currentValue) >=
          parseFloat(currentQuestion.goal) &&
        parseFloat(currentQuestion.currentValue) <=
          parseFloat(currentQuestion.goal);
      goalValue = currentQuestion.goal;
      break;
    case "Pressure":
      asistolic = currentQuestion.currentValue.split("/")[0];
      diastolic = currentQuestion.currentValue.split("/")[1];
      asistolicMin = currentQuestion.minGoal.split("/")[0];
      asistolicMax = currentQuestion.maxGoal.split("/")[0];
      diastolicMin = currentQuestion.minGoal.split("/")[1];
      diastolicMax = currentQuestion.maxGoal.split("/")[1];

      if (
        parseFloat(asistolic) >= parseFloat(asistolicMin) &&
        parseFloat(asistolic) <= parseFloat(asistolicMax) &&
        parseFloat(diastolic) >= parseFloat(diastolicMin) &&
        parseFloat(diastolic) <= parseFloat(diastolicMax)
      ) {
        stateValue = true;
      } else {
        stateValue = false;
      }
      goalValue =
        currentQuestion.minGoal.replace("/", "-") +
        " / " +
        currentQuestion.maxGoal.replace("/", "-");
      break;
    default:
      switch (currentQuestion.currentValue) {
        case "Bien":
          stateValue = true;
          break;
        case "Regular":
          stateValue = true;
          break;
        case "Mal":
          stateValue = false;
          break;
      }
      goalValue = currentQuestion.goal;
      break;
  }

  let stateDescription = stateValue ? "Controlado" : "No controlado";
  let colorStatus = stateValue ? "#00b189" : "#ffb600";
  //If have value show card
  return (
    <div
      className="card"
      style={{
        boxShadow: "4px 4px 10px rgba(0, 0, 0, .15)",
      }}
    >
      <div
        className="card-header"
        style={{
          borderBottom: "2px solid lightgray",
          textAlign: "center",
          padding: "10px 0",
        }}
      >
        <h4 style={{ margin: "0" }}>{currentQuestion.question}</h4>
      </div>
      <div className="card-body">
        {!currentQuestion.currentValue && (
          <Empty description="No existe información" />
        )}
        {currentQuestion.currentValue && (
          <div className="row">
            <div className="col-12" style={{ textAlign: "center" }}>
              <b>Meta: </b>

              <strong>
                {goalValue}{" "}
                {currentQuestion.measureText ? currentQuestion.measureText : ""}
              </strong>
            </div>
            <div
              className=" col-12 mb-2"
              style={{
                color: colorStatus,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <FeatherIcon
                icon={stateValue ? "thumbs-up" : "thumbs-down"}
                style={{ marginRight: "2px" }}
                size={40}
              ></FeatherIcon>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <b>{stateDescription} </b>

                <strong>
                  {currentQuestion.currentValue} {currentQuestion.measureText}
                </strong>
              </div>
            </div>
          </div>
        )}
      </div>
      {questions.length > 1 && (
        <div
          className="card-footer"
          style={{
            textAlign: "center",
            padding: "10px 0",
            backgroundColor: "white",
          }}
        >
          <div style={{ display: "flex", justifyContent: "center" }}>
            <button
              className="btn"
              onClick={handlePreviousQuestion}
              disabled={currentQuestionIndex === 0}
            >
              <FeatherIcon
                icon={"arrow-left"}
                style={{ marginRight: "2px" }}
                size={18}
              ></FeatherIcon>
            </button>
            <button
              className="btn"
              onClick={handleNextQuestion}
              disabled={currentQuestionIndex === questions.length - 1}
            >
              <FeatherIcon
                icon={"arrow-right"}
                style={{ marginRight: "2px" }}
                size={18}
              ></FeatherIcon>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

QuestionProfileCard.propTypes = {
  questions: arrayOf(
    shape({
      question: string.isRequired,
      measure: string,
      measureText: string,
      currentValue: string.isRequired,
      goal: string,
      maxGoal: string,
      minGoal: string,
    })
  ),
};

export default QuestionProfileCard;
